// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Duplicate / Inconsistency Detection (BN29)
// Deterministic similarity scoring. Never auto-merges.
// ══════════════════════════════════════════════════════
function renderDuplicateDetectionTab() {
  var dupes = detectDuplicates()
  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px"><h2 style="font-size:20px;font-weight:700">Duplicate Detection</h2><div class="spacer"></div>' +
    '<button class="btn btn-secondary btn-sm" onclick="render()">Re-scan</button></div>' +
    (dupes.length === 0 ? '<div class="card" style="padding:24px;text-align:center;color:var(--green);font-weight:600">\u2713 No duplicates detected</div>' :
      dupes.map(function(d) {
        return '<div class="card" style="margin-bottom:8px;padding:12px;border-left:3px solid var(--amber)">' +
          '<div style="font-size:13px;font-weight:600">' + esc(d.type) + ': possible duplicate</div>' +
          '<div style="font-size:12px;color:var(--text3);margin-top:4px">"' + esc(d.nameA) + '" \u2194 "' + esc(d.nameB) + '"</div>' +
          '<div style="font-size:11px;color:var(--text4);margin-top:2px">Similarity: ' + d.score + '% \u2014 ' + esc(d.reason) + '</div>' +
        '</div>'
      }).join('')) +
  '</div>'
}
function detectDuplicates() {
  var dupes = []
  // Peptide name similarity
  var peps = (S.peptides || []).filter(function(p) { return !p.archived })
  for (var i = 0; i < peps.length; i++) {
    for (var j = i + 1; j < peps.length; j++) {
      var score = nameSimilarity(peps[i].name, peps[j].name)
      if (score >= 70) dupes.push({ type: 'Peptide', nameA: peps[i].name, nameB: peps[j].name, score: score, reason: 'Name similarity', idA: peps[i].id, idB: peps[j].id })
    }
  }
  // Vendor name similarity
  var vends = (S.vendors || [])
  for (var vi = 0; vi < vends.length; vi++) {
    for (var vj = vi + 1; vj < vends.length; vj++) {
      var vs = nameSimilarity(vends[vi].name, vends[vj].name)
      if (vs >= 75) dupes.push({ type: 'Vendor', nameA: vends[vi].name, nameB: vends[vj].name, score: vs, reason: 'Name similarity', idA: vends[vi].id, idB: vends[vj].id })
    }
  }
  // Lab marker name similarity
  var markers = {};(S.labResults || []).forEach(function(p) { (p.markers || []).forEach(function(m) { markers[m.name] = true }) })
  var mNames = Object.keys(markers)
  for (var mi = 0; mi < mNames.length; mi++) {
    for (var mj = mi + 1; mj < mNames.length; mj++) {
      var ms = nameSimilarity(mNames[mi], mNames[mj])
      if (ms >= 80) dupes.push({ type: 'Lab Marker', nameA: mNames[mi], nameB: mNames[mj], score: ms, reason: 'Name similarity — consider adding as alias' })
    }
  }
  return dupes.sort(function(a, b) { return b.score - a.score })
}
function nameSimilarity(a, b) {
  if (!a || !b) return 0
  var la = a.toLowerCase().replace(/[^a-z0-9]/g, ''), lb = b.toLowerCase().replace(/[^a-z0-9]/g, '')
  if (la === lb) return 100
  if (la.indexOf(lb) >= 0 || lb.indexOf(la) >= 0) return 85
  // Levenshtein-based
  var len = Math.max(la.length, lb.length)
  if (len === 0) return 100
  var dist = levenshtein(la, lb)
  return Math.round((1 - dist / len) * 100)
}
function levenshtein(a, b) {
  var m = a.length, n = b.length, d = []
  for (var i = 0; i <= m; i++) { d[i] = [i] }
  for (var j = 0; j <= n; j++) { d[0][j] = j }
  for (var i2 = 1; i2 <= m; i2++) {
    for (var j2 = 1; j2 <= n; j2++) {
      d[i2][j2] = Math.min(d[i2-1][j2] + 1, d[i2][j2-1] + 1, d[i2-1][j2-1] + (a[i2-1] === b[j2-1] ? 0 : 1))
    }
  }
  return d[m][n]
}
export { renderDuplicateDetectionTab, detectDuplicates, nameSimilarity }
